import React__default from 'react';
import isEmpty from 'lodash/isEmpty';
import { Types } from '@grandvisionhq/auth';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import { ShippingObjectTypes } from '../../state.js';
import { togglePrefill } from '../actions.js';
import { getShippingDetails, isUserDataPrefilled, isBillingAddressReady, isContactDetailsReady, isDeliveryAddressReady } from '../selectors.js';
import { PrefillSources } from '../types.js';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';

const useFormPrefill = (userData)=>{
    const checkoutSettings = useCheckoutSettings();
    const dispatch = useDispatch();
    const shippingDetails = useSelector(getShippingDetails);
    const isUserDataPrefilledBoolean = useSelector(isUserDataPrefilled);
    const isBillingFormReady = useSelector(isBillingAddressReady);
    const isContactFormReady = useSelector(isContactDetailsReady);
    const isDeliveryFormReady = useSelector(isDeliveryAddressReady);
    const prefillUserData = React__default.useCallback((result)=>{
        if (!shippingDetails) return;
        const mapping = {
            [Types.FormName.billingAddress]: ShippingObjectTypes.BillingAddress,
            [Types.FormName.personalDetails]: ShippingObjectTypes.ContactDetails
        };
        Object.entries(mapping).filter(([, checkoutFormName])=>!isEmpty(shippingDetails[checkoutFormName])
        ).forEach(([authFormName, checkoutFormName])=>{
            if (!checkoutFormName) {
                return;
            }
            dispatch(togglePrefill({
                source: PrefillSources.UserData,
                email: result.email,
                data: result,
                targetFormState: shippingDetails[checkoutFormName],
                sourceFormName: authFormName,
                targetFormName: checkoutFormName
            }));
        });
    }, [
        dispatch,
        shippingDetails
    ]);
    const prefillCartData = React__default.useCallback((shippingDetailsCart)=>{
        if (!shippingDetails || !shippingDetailsCart) return;
        const billingPrefillRequired = (shippingDetailsCart === null || shippingDetailsCart === void 0 ? void 0 : shippingDetailsCart.billingAddress) ? isBillingFormReady : true;
        const customerPrefillRequired = (shippingDetailsCart === null || shippingDetailsCart === void 0 ? void 0 : shippingDetailsCart.customer) ? isContactFormReady : true;
        const deliveryPrefillRequired = (shippingDetailsCart === null || shippingDetailsCart === void 0 ? void 0 : shippingDetailsCart.deliveryAddress) ? isDeliveryFormReady : true;
        if (billingPrefillRequired && customerPrefillRequired) {
            const mapping = {
                billingAddress: ShippingObjectTypes.BillingAddress,
                customer: ShippingObjectTypes.ContactDetails
            };
            Object.entries(mapping).forEach(([sourceFormName, checkoutFormName])=>{
                var ref;
                dispatch(togglePrefill({
                    source: PrefillSources.Cart,
                    email: (ref = shippingDetailsCart.customer) === null || ref === void 0 ? void 0 : ref.email,
                    data: shippingDetailsCart,
                    targetFormState: shippingDetails[checkoutFormName],
                    sourceFormName,
                    targetFormName: checkoutFormName
                }));
            });
        }
        if ((shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.deliveryAddress.isEnabled) && deliveryPrefillRequired) {
            var ref1;
            dispatch(togglePrefill({
                source: PrefillSources.Cart,
                email: (ref1 = shippingDetailsCart.customer) === null || ref1 === void 0 ? void 0 : ref1.email,
                data: shippingDetailsCart,
                targetFormState: shippingDetails[ShippingObjectTypes.DeliveryAddress],
                sourceFormName: 'deliveryAddress',
                targetFormName: ShippingObjectTypes.DeliveryAddress
            }));
        }
    }, [
        dispatch,
        isBillingFormReady,
        isContactFormReady,
        isDeliveryFormReady,
        shippingDetails
    ]);
    React__default.useEffect(()=>{
        if (isUserDataPrefilledBoolean || !isBillingFormReady || !isContactFormReady) {
            return;
        } else {
            /**
       *  Prefill information from the opco context
       */ const shippingDetailsCart = checkoutSettings.shippingDetails;
            /**
       *  Prefill information from cart
       */ if (shippingDetailsCart && !isEmpty(shippingDetailsCart)) {
                prefillCartData(shippingDetailsCart);
            }
            /**
       *  Prefill information from MyAccount
       */ if (isEmpty(shippingDetailsCart) && userData) {
                prefillUserData(userData.result);
            }
        }
    // Added eslint rule because prefillUserData & prefillCartData in the dependency array triggers an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userData === null || userData === void 0 ? void 0 : userData.status,
        isBillingFormReady,
        isContactFormReady,
        checkoutSettings,
        isUserDataPrefilledBoolean, 
    ]);
};

export { useFormPrefill };
//# sourceMappingURL=use-form-prefill.js.map
